module.exports = "<app-auth-header></app-auth-header>\r\n<ng-content select=\"router-outlet\"></ng-content>\r\n"